export function isUserSignedIn(): boolean {
  return (window as any).g_opt.user.id > 0;
}
